//DEFAULTS
import "imports/core-js/stable";
import "imports/regenerator-runtime/runtime";

import site from 'site/site'
import siteScroll from 'site/scroll'
$(document).ready(function() {
    site.init()
    siteScroll.init()
})
